import { createSlice } from "@reduxjs/toolkit";
import { getTranslations } from "../../data";

const initialState = getTranslations();

export const translationSlice = createSlice({
  name: "translation",
  initialState,
  reducers: {},
});

export const { setLanguage } = translationSlice.actions;

export const selectLanguage = (state) => state.translation.language;
export const selectText = (state) => {
  return (id) => {
    const text =
      state.translation[state?.context?.user?.state?.language || "global"]?.[
        id
      ] || state.translation["global"]?.[id];

    return text;
  };
};

export default translationSlice.reducer;
